<template>
  <div ref="messagesContainer" class="chat-messages">
    <div v-if="chatBotStore.messages.length === 0" class="empty-state">
      <div class="empty-icon">💬</div>
      <p>No messages yet. Start a conversation!</p>
    </div>

    <div v-for="message in chatBotStore.messages" :key="message.id" :class="['message', message.type]">
      <div class="message-avatar">
        <div v-if="message.type === 'user'" class="user-avatar">U</div>
        <div v-else class="bot-avatar">🤖</div>
      </div>

      <div class="message-content">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="message-text" v-html="sanitizeHtml(message.text)"></div>
        <div class="message-time">{{ formatTime(message.timestamp) }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useChatBotStore } from "../stores/chatBotStore";
import { formatTime, scrollToBottom } from "../helpers/common";
import { onMounted, ref, watch } from "vue";
import DOMPurify from "dompurify";

const chatBotStore = useChatBotStore();

const messagesContainer = ref<HTMLElement>();

//Use package to sanitize HTML content to prevent XSS attacks
const sanitizeHtml = (html: string) => DOMPurify.sanitize(html);

onMounted(() => {
  scrollToBottom(messagesContainer.value!);
});

watch(
  () => chatBotStore.messages,
  () => {
    scrollToBottom(messagesContainer.value!);
  },
  { deep: true }
);
</script>
